import React, { useEffect, useState } from "react";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty, find, sumBy, filter } from "lodash";
import { getUserRes } from "../../AddUser/user.actions";
import { setHeading } from "../../../accounts/account.actions";
import { GetAreaApi } from "../AddArea/areaAction";
import { GetShopByAreaApi } from "../AddShop/Shop.action";
import { getProductData } from "../AddProduct/Product.action";
import { AddOrderBookingApi, clearShopLedger, searchAccountLedgerTable } from "./OrderBookingAction";
import Select from "react-select";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import moment from "moment";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const AddOrderBooking = (props) => {
  const [areaName, setAreaName] = useState("");
  const [areaId, setAreaId] = useState();
  const [check, setCheck] = useState(false);
  const [shopName, setShopName] = useState("");
  const [bookerId, setBookerId] = useState("");
  const [bookerName, setBookerName] = useState("");
  const [shopId, setShopId] = useState();
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [grandTotal, setGrandTotal] = useState();
  const [subTotal, setSubTotal] = useState();
  const [tax, setTax] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [tradeOffer, setTradeOffer] = useState(0);
  const [inputField, setInputField] = useState([{
    code: "",
    productLabel: "",
    quantity: 0,
    purchasePrice: 0,
    salePrice: 0,
    wholesalePrice: 0,
    productTotalAmount: 0,
  }]);

  function SaveOrder() {
    props.AddOrderBookingApi({
      orderDate: date,
      areaId: areaId,
      shopId: shopId,
      shopOldBalance: isEmpty(props.shopLedgerData) ? 0 : props.shopLedgerData?.closingBalance,
      bookerId: bookerId,
      subTotal: subTotal,
      discount: totalDiscount,
      tradeOffer: tradeOffer,
      tax: tax,
      taxAmount: taxAmount,
      grandTotal: grandTotal,
      items: inputField,
      platform: 'Web',
      dateShow: moment(date).format('llll'),
    },
      showSuccessAlert,
      showErrorAlert
    );
    setAreaName("");
    setAreaId("");
    setShopName("");
    setShopId("");
    setBookerId("");
    setBookerName("");
    setGrandTotal("");
    setSubTotal("");
    setTax(0);
    setTotalDiscount(0);
    setTradeOffer(0);
    props.clearShopLedger();
    setInputField([{
      code: "",
      productLabel: "",
      quantity: 0,
      purchasePrice: 0,
      salePrice: 0,
      wholesalePrice: 0,
      productTotalAmount: 0,
    }]);
  }

  const handleChangeArea = (selectedOption) => {
    setAreaId(selectedOption.value);
    setAreaName(selectedOption.label);
    props.GetShopByAreaApi(selectedOption.value);
    handleCheck([{
      code: "",
      productLabel: "",
      quantity: 0,
      purchasePrice: 0,
      salePrice: 0,
      wholesalePrice: 0,
      productTotalAmount: 0,
    }])
  };
  const AreaListData = isEmpty(props.areaDataList) ? [] : props.areaDataList.map((x) => {
    let data = { value: x._id, label: x.areaName };
    return data;
  });


  const handleChangeShop = (selectedOption) => {
    setShopId(selectedOption.value);
    setShopName(selectedOption.label);
    props.searchAccountLedgerTable({ levelFourId: selectedOption.value, })
  };
  const ShopListData = isEmpty(props.shopsByAreaList) ? [] : props.shopsByAreaList.map((x) => {
    let data = { value: x._id, label: x.shopName };
    return data;
  });


  const handleChangeBooker = (selectedOption) => {
    setBookerId(selectedOption.value);
    setBookerName(selectedOption.label);
  };
  const filterdUserList = isEmpty(props.userList) ? [] : props.userList.filter((e) => e.role === "booker");
  const BookerList = isEmpty(filterdUserList) ? [] : filterdUserList.map((x) => {
    let data = { value: x._id, label: x.userName };
    return data;
  });


  const product = props.productDataList.map((x) => {
    let data = {
      value: x._id,
      label: x.name,
      code: x.code,
      avaliableQuantity: x.productBalance,
      purchasePrice: x.purchasePrice,
      salePrice: x.salePrice,
    };
    return data;
  });


  const handleChange = (e, index, type) => {
    setInputField(prev => {
      const list = [...prev];
      const item = { ...list[index] };

      if (type === "intquantity") {
        const qty = Number(e.target.value);
        if (qty > item.avaliableQuantity) {
          showErrorAlert("Quantity cannot be greater than Available Quantity");
          item.quantity = item.avaliableQuantity;
        } else {
          item.quantity = qty;
        }
      }

      if (type === "intname") {
        const product = props.productDataList.find(p => p._id === e.value);

        if (product) {
          Object.assign(item, {
            code: e.code,
            product: e.value,
            productLabel: e.label,
            avaliableQuantity: e.avaliableQuantity,
            quantity: 0,
            wholesalePrice: Number(product.wholesalePrice),
            purchasePrice: Number(product.purchasePrice),
            salePrice: Number(product.salePrice),
          });
        }
      }

      if (type === "salePrice") {
        item.salePrice = Number(e.target.value);
      }

      item.productTotalAmount = item.salePrice * item.quantity;
      list[index] = item;
      const subTotal = sumBy(list, "productTotalAmount");
      setSubTotal(subTotal);

      handleCheck(list);
      return list;
    });
  };
  const handleAddInput = () => {
    setInputField([
      ...inputField,
      {
        code: "",
        productLabel: "",
        quantity: 0,
        purchasePrice: 0,
        salePrice: 0,
        wholesalePrice: 0,
        productTotalAmount: 0,
      },
    ]);
    handleCheck([
      ...inputField,
      {
        code: "",
        productLabel: "",
        quantity: 0,
        purchasePrice: 0,
        salePrice: 0,
        wholesalePrice: 0,
        productTotalAmount: 0,
      },
    ])
  };
  const handleCheck = (data) => {
    const test = filter(data, { "productLabel": "" })
    isEmpty(test) ? setCheck(true) : setCheck(false)
  };
  const handleRemoveInput = (index) => {
    const list = [...inputField];
    list.splice(index, 1);
    setInputField(list);
    setSubTotal(sumBy(list, "productTotalAmount"));
    setGrandTotal(sumBy(list, "productTotalAmount") - (Number(totalDiscount) + Number(tradeOffer)));
    handleCheck(list)
  };


  useEffect(() => {
    props.setHeading("Order Booking");
    props.GetAreaApi();
    props.getProductData();
    props.getUserRes();
  }, []);

  useEffect(() => {
    const sub = Number(subTotal) || 0;
    const discount = Number(totalDiscount) || 0;
    const offer = Number(tradeOffer) || 0;
    const taxPercent = Number(tax) || 0;

    // ✅ Tax on FULL subtotal (no discount applied here)
    const calculatedTaxAmount = (taxPercent / 100) * sub;

    // ✅ Grand total AFTER tax, then subtract discount
    const finalTotal = sub + calculatedTaxAmount - (discount + offer);

    setTaxAmount(calculatedTaxAmount);
    setGrandTotal(finalTotal);
  }, [tax, totalDiscount, tradeOffer, subTotal]);


  return (
    <>
      {props.isAddingOrderBooking || props.isFetchingAreaData || props.isFetchingUser || props.isFetchingProduct ? (
        <GlobalSpinner />
      ) : (
        <Container fluid>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Date *</b></Form.Label>
                <Form.Control
                  type="date"
                  value={date}
                  // min={moment(new Date()).format("YYYY-MM-DD")}
                  onChange={(e) => setDate(e.target.value)}
                ></Form.Control>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Select Area *</b></Form.Label>
                <Select
                  isDisabled={isEmpty(props.areaDataList)}
                  value={{ label: areaName }}
                  placeholder="Select Area"
                  onChange={(e) => { handleChangeArea(e); }}
                  options={AreaListData}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Select Shop *</b></Form.Label>
                <Select
                  isDisabled={isEmpty(props.shopsByAreaList) || isEmpty(areaName)}
                  placeholder="Select Shop"
                  onChange={handleChangeShop}
                  options={ShopListData}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Shop Balance </b> </Form.Label>
                <Form.Control
                  value={isEmpty(props.shopLedgerData) ? '' : `${props.shopLedgerData?.closingBalance} - ${props.shopLedgerData?.closingBalanceSign}`}
                  disabled
                  type="text"
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Select DSF *</b></Form.Label>
                <Select
                  isDisabled={isEmpty(BookerList)}
                  value={{ label: bookerName }}
                  placeholder="Select DSF"
                  onChange={handleChangeBooker}
                  options={BookerList}
                />
              </Form.Group>
            </Col>
          </Row>

          {inputField.map((item, i) => {
            return (
              <React.Fragment key={i}>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label><b>Select Product *</b></Form.Label>
                      <Select
                        value={{ label: item.productLabel }}
                        placeholder="Select Product"
                        isDisabled={isEmpty(shopName)}
                        onChange={(e) => handleChange(e, i, "intname")}
                        options={product}
                        isOptionDisabled={(option) => !isEmpty(find(inputField, (x) => x.product == option.value))}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label><b>Avaliable Quantity</b> </Form.Label>
                      <Form.Control
                        type="number"
                        disabled
                        placeholder="Quantity"
                        name="Quantity"
                        value={item.avaliableQuantity}
                        min={0}
                        onChange={(e) => handleChange(e, i, "intquantity")}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label><b>Quantity *</b></Form.Label>
                      <Form.Control
                        type="number"
                        disabled={isEmpty(shopName)}
                        placeholder="Quantity"
                        name="Quantity"
                        value={item.quantity}
                        min={0}
                        max={item.avaliableQuantity}
                        onChange={(e) => handleChange(e, i, "intquantity")}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label><b>Price *</b></Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Product Price"
                        name="Product Price"
                        value={item.salePrice}
                        disabled={isEmpty(shopName)}
                        min={0}
                        onChange={(e) => handleChange(e, i, "salePrice")}
                        isOptionDisabled={(option) => !isEmpty(find(inputField, (x) => x.product == option.value))}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label><b>Total Price</b></Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Total Price"
                        name="TotalPrice"
                        disabled
                        value={item.productTotalAmount}
                      />
                    </Form.Group>
                  </Col>
                  <Col style={{ marginTop: "30px" }}>
                    {inputField.length - 1 == i && (
                      <Button
                        title="Click to Add Product"
                        onClick={handleAddInput}
                        style={{ float: "right", color: "white", backgroundColor: '#81ABD3' }}  >
                        <AddIcon />
                      </Button>
                    )}
                    {inputField.length !== 1 && (
                      <Button
                        title="Click to Remove Product"
                        onClick={() => handleRemoveInput(i)}
                        style={{ float: "right", color: "white", backgroundColor: '#81ABD3', marginRight: "10px" }} >
                        <RemoveIcon />
                      </Button>
                    )}
                  </Col>
                </Row>
              </React.Fragment>
            );
          })}
          <Row>
            <Col>
              <Form.Group className="mb-3 mt-3">
                <Form.Label><b>Sub Total </b></Form.Label>
                <Form.Control
                  value={subTotal}
                  disabled
                  type="number"
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3 mt-3">
                <Form.Label><b>Discount</b></Form.Label>
                <Form.Control
                  value={totalDiscount}
                  // disabled={inputField[0].productLabel === ""}
                  type="number"
                  min={0}
                  max={subTotal}
                  onChange={(e) => { const value = Number(e.target.value); if (value <= subTotal) setTotalDiscount(value); }}
                />
              </Form.Group>
            </Col>
            {/* <Col>
              <Form.Group className="mb-3 mt-3">
                <Form.Label><b>Trade Offer</b></Form.Label>
                <Form.Control
                  value={tradeOffer}
                  disabled={true}
                  type="number"
                  min={0}
                  onChange={(e) => { const value = Number(e.target.value); setTradeOffer(value); }}
                />
              </Form.Group>
            </Col> */}
            <Col>
              <Form.Group className="mb-3 mt-3">
                <Form.Label><b>FBR Tax (%)</b></Form.Label>
                <Form.Control
                  value={tax}
                  // disabled={inputField[0].productLabel == ""}
                  type="number"
                  min={0}
                  onChange={(e) => setTax(Number(e.target.value))}
                  placeholder="Enter tax percentage"
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3 mt-3">
                <Form.Label><b>Tax Amount</b></Form.Label>
                <Form.Control
                  value={taxAmount.toFixed(2)}
                  disabled
                  type="number"
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3 mt-3">
                <Form.Label> <b>Grand Total</b> </Form.Label>
                <Form.Control
                  value={grandTotal}
                  disabled
                  type="number"
                // onChange={(e) => { setGrandTotal(e.target.value) }}
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="sendDiv">
            {isEmpty(areaId) || isEmpty(shopId) || isEmpty(bookerId) || inputField.some((fields) => isEmpty(fields.productLabel) || fields.quantity <= 0) ? (
              <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
            ) : (
              <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SaveOrder}> SAVE </Button>
            )}
          </div>

        </Container>
      )}
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    AddOrderBookingApi: (data, showSuccessAlert, showErrorAlert) => dispatch(AddOrderBookingApi(data, showSuccessAlert, showErrorAlert)),
    GetAreaApi: () => dispatch(GetAreaApi()),
    GetShopByAreaApi: (shopId) => dispatch(GetShopByAreaApi(shopId)),
    setHeading: (data) => dispatch(setHeading(data)),
    getUserRes: () => dispatch(getUserRes()),
    getProductData: () => dispatch(getProductData()),
    searchAccountLedgerTable: (data) => dispatch(searchAccountLedgerTable(data)),
    clearShopLedger: () => dispatch(clearShopLedger()),
  };
};
const mapStateToProps = (state, ownProps) => ({
  isAddingOrderBooking: state.OrderBookingReducer.isAddingOrderBooking,
  isFetchingAreaData: state.AreaReducer.isFetchingAreaData,
  areaDataList: state.AreaReducer.areaDataList,
  isFetchingShopsByArea: state.ShopReducer.isFetchingShopsByArea,
  shopsByAreaList: state.ShopReducer.shopsByAreaList,
  isFetchingUser: state.UserReducer.isFetchingUser,
  userList: state.UserReducer.userList,
  isFetchingProduct: state.ProductReducer.isFetchingProduct,
  productDataList: state.ProductReducer.productDataList,
  shopLedgerData: state.OrderBookingReducer.shopLedgerData,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddOrderBooking);